export enum SocialMode {
  Instagram = 'instagram',
  Facebook = 'facebook',
  Twitter = 'twitter',
  Copy = 'copy',
}
